import type { StoreType } from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';

let store: StoreType;

const setStore = (newStore: StoreType): void => {
  store = newStore;
};

/**
 * If access to the store is needed in a React component it is expected to use the `useSelector` hook.
 *
 * In rare cases access is needed in a utility where useSelector is not available, and it would be inefficient to pass the store as an argument.
 *
 * In those cases this function can be used.
 *
 * @returns {StoreType} The Redux store, if called after the store has been initialised
 */
const getStore = (): StoreType => store;

export { getStore, setStore };
